import React, { useEffect } from 'react'
import InputField from '../InputField'
import Text from '../Text'
import BottomSheet from '../BottomSheet'
import useGetStateAndCity from './hooks/useGetStateAndCity'
import Spinner from '../Spinner'
import ChevronDownIcon from '../Icons/ChevronRight'
import SearchIcon from '../Icons/SearchIcon'
import ProceedButton from './ProceedButton'

const CityPicker = ({ value, onChange, formObj, onMoveNext, isLastStep }) => {
  const {
    cityList,
    stateList,
    stateListLoading,
    cityListLoading,
    selectedState,
    selectedCity,
    filteredStateList,
    activeSection,
    setActiveSection,
    handleOnStateSearch,
    searchQuery,
    handleOnSearch,
    handleCityClick,
    setSelectedState,
    setSelectedCity,
  } = useGetStateAndCity({ onChange })

  useEffect(() => {
    if (formObj?.state && stateList?.length > 0) {
      const state = stateList?.find(
        (item) => item?.state_name === formObj?.state,
      )
      setSelectedState(state)
      setSelectedCity(null)
    }
  }, [formObj?.state, stateList])

  useEffect(() => {
    if (formObj?.city && !selectedState?.city_name) {
      setSelectedCity({ city_name: formObj?.city })
    }
  }, [formObj?.city])

  return (
    <div className="pt-12 px-4">
      <div className="space-y-3 pb-4">
        <Text
          tag="h2"
          variant="display"
          size="small"
          className="text-[#101828]"
        >
          Where do you <br /> reside?
        </Text>

        <Text tag="p" variant="body" size="medium" className="text-[#475467]">
          Your location helps us personalise your care for better support
        </Text>
      </div>

      <div className="flex flex-col gap-5 mt-6">
        <div onClick={() => setActiveSection('state')}>
          <InputField
            name="state"
            label="Select State"
            type="text"
            placeholder="Select your State"
            value={selectedState?.state_name}
            readOnly={true}
            rightIcon={
              stateListLoading ? (
                <Spinner />
              ) : (
                <ChevronDownIcon className="rotate-90" />
              )
            }
          />
        </div>
        <div
          key={selectedState?.state_master_id}
          onClick={() =>
            selectedState?.state_master_id ? setActiveSection('city') : null
          }
        >
          <InputField
            name="city"
            label="Select City"
            type="text"
            placeholder="Select your City"
            value={selectedCity?.city_name}
            readOnly={true}
            rightIcon={
              cityListLoading ? (
                <Spinner />
              ) : (
                <ChevronDownIcon className="rotate-90" />
              )
            }
          />
        </div>

        <ProceedButton
          onMoveNext={onMoveNext}
          isLastStep={isLastStep}
          disabled={!selectedState?.state_name || !selectedCity?.city_name}
        />
      </div>

      {/* state list */}
      <BottomSheet
        show={Boolean(activeSection === 'state')}
        onClose={() => setActiveSection(null)}
        title={`Select your state`}
      >
        <div className="min-h-[80vh] max-h-[80vh] px-4 pt-5 space-y-5">
          <div>
            <InputField
              name="state"
              // label="State"
              type="text"
              placeholder="Enter your State"
              onChange={handleOnStateSearch}
              value={searchQuery}
              rightIcon={
                stateListLoading ? (
                  <Spinner />
                ) : (
                  <div className="relative h-full w-full">
                    <SearchIcon />
                  </div>
                )
              }
            />
          </div>
          <div className="max-h-[70vh] overflow-y-auto px-2 pb-3">
            <ul className="space-y-4">
              {filteredStateList?.map((item) => (
                <li
                  key={item?.state_master_id}
                  onClick={() => handleCityClick(item, item?.state_name)}
                >
                  <Text
                    tag="p"
                    variant="body"
                    size="large"
                    className="text-[#667085]"
                  >
                    {item?.state_name}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </BottomSheet>

      {/* city list */}
      <BottomSheet
        show={Boolean(activeSection === 'city')}
        onClose={() => setActiveSection(null)}
        title={`Select your city`}
      >
        <div className="min-h-[80vh] max-h-[80vh] px-4 pt-5 space-y-5">
          <div>
            <InputField
              name="city"
              // label="City"
              type="text"
              placeholder="Enter your City"
              onChange={handleOnSearch}
              value={searchQuery}
              rightIcon={
                cityListLoading ? (
                  <Spinner />
                ) : (
                  <div className="relative h-full w-full">
                    <SearchIcon />
                  </div>
                )
              }
            />
          </div>
          <div className="max-h-[70vh] overflow-y-auto px-2 pb-3">
            <ul className="space-y-4">
              {cityList?.map((item) => (
                <li
                  key={item?.city_master_id}
                  onClick={() => handleCityClick(item, item?.city_name)}
                >
                  <Text
                    tag="p"
                    variant="body"
                    size="large"
                    className="text-[#667085]"
                  >
                    {item?.city_name}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </BottomSheet>
    </div>
  )
}

export default CityPicker
